<template>
  <el-card shadow="hover">
    <div style="padding: 10px 20px">
      <div v-if="batchExportSubmit">
        <span>
          <i class="el-icon-loading"></i>
          正在导出数据中，请勿离开此页面
        </span>
      </div>
      <div v-else>
        <el-button size="small" type="primary" @click="batchExportSubmitClick">
          导出
        </el-button>
      </div>
      <div style="line-height: 22px; margin-top: 20px">
        <div>
          <span style="font-weight: 500"> 批量导出操作须知 </span>
        </div>
        <div>
          <span>
            1，导出更新处理时间较长，请耐心等待，请勿中途关闭或退出当前界面
          </span>
        </div>
        <div>
          <span> 2，导出完成后及时检查导出文件的完整性和准确性 </span>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      batchExportSubmit: false
    }
  },
  methods: {
    batchExportSubmitClick() {
      this.batchExportSubmit = true;
      this.requestApi("biz.goods.sku.info.export", {
      }, { showError: true, download: true }).finally(() => {
        this.batchExportSubmit = false;
      });
    },
  }
}
</script>